import { ITranslationModel } from "@models/interface-management/localization";

export interface IUserRole {
  id: number;
  name: ITranslationModel;
  homeMenuItem: any;
  homeMenuItemId: number;
  homePage: string;
  normalizedName: string;
  value?: boolean;
  isMainRole?: boolean;
  code: string;
  homePageMenuItemUrl: string | null;
  appPermissions?: number[];
  settings: string;
  settingTooltip: string;
}

export enum UserRoleEnum {
  FleetOwnerSupervisor = "FleetOwnerSupervisor",
  FleetOwner = "FleetOwner",
  ServiceWorkProcessor = "ServiceWorkProcessor",
  Requestor = "Requestor",
  Admin = "Admin",
  BusinessPartner = "BusinessPartner", //for OKTA users,
  Reader = "Reader",
}
